import { atom } from 'jotai';

export const sessionOverridesAtom = atom(new Set<string>());
